import { DataSecurityAlert } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityAlertsRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityAlertsResponse = PaginatedResource<DataSecurityAlert>;

export const getDataSecurityAlerts = createGetEndpoint<GetDataSecurityAlertsRequest, GetDataSecurityAlertsResponse>(
	(request) => `/api/v3/data-security/alerts?${getQueryString(request)}`
);
